import React from 'react';

import {
  StoreTypeName,
  useAdminStoreSettingsActivityQuery,
  useArchiveStoreMutation
} from 'generated/graphql';



export interface IData {
  storeType: StoreTypeName;
}

export function useQuery(storeId: string) {
  const tuple = useAdminStoreSettingsActivityQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        storeType: tuple.data?.store?.type.name ?? 'customizableFormat'
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useArchiveStore(storeId: string) {
  const [fnMutate, tuple] = useArchiveStoreMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async () => {
      await fnMutate({
        variables: {
          storeId
        }
      });
    },
    [
      fnMutate,
      storeId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
